angular.module("app").controller("HomePageController", ['$scope', 'userStorage', 'settingsService', 'userService', 'errorHandler',
    function ($scope, userStorage, settingsService, userService, errorHandler) {
        var settings = settingsService.getSettings();
        $scope.user = userStorage.getUserData();
        $scope.menu_switcher = true;
        $scope.skinName = settings.skin && settings.skin.name;

        $scope.closeMain = function () {
            $scope.menu_switcher = true;
        };

        $scope.navigateToNewCms = function navigateToNewCms() {
            userService.navigateToNewCms().then(function (response) {
                if (response.status === 'ok') {
                    return window.open(response.redirectTo, '_blank')
                }
                errorHandler(response.message);

            }, function (error) {
                errorHandler(error.message);
            })
        }

    }
]);
